// extracted by mini-css-extract-plugin
export default {"wellness-card-skeleton":"WellnessCardSkeleton_wellness-card-skeleton__LZerJ"};